//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vuejs-accessibility/alt-text */
import { mdiAlert } from '@mdi/js'
import { useUtils } from '@core/libs/i18n'

export default {
  setup() {
    const { t } = useUtils()

    return {
      t,
      icons: {
        mdiAlert,
      },
    }
  },
}
